"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpgradeService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
const http_1 = require("@angular/common/http");
class UpgradeService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.deviceReplacementFee = '/rest-api/account/sub/device/upgrade/v1/drf/';
        this.installmentDetails = '/rest-api/account/sub/installment/v1/details/';
        this.bbdeviceUpgradeUrl = '/rest-api/account/sub/device/upgrade/v1/business/';
        this.tradeInCreditUrl = '/rest-api/account/sub/installment/v1/tradeInCredit/';
        this.isEarlyUpgradeEligibleUrl = '/rest-api/earlyUpgrade/v1/isEarlyUpgradeEligible?subId=';
    }
    getDeviceReplacementFee(subId) {
        return this.get(this.deviceReplacementFee + subId).pipe(operators_1.map((data) => data));
    }
    getInstallmentDetails(subId) {
        return this.get(this.installmentDetails + subId).pipe(operators_1.map((data) => data));
    }
    deviceUpgrade(subscrptionId) {
        const inputArgs = new http_1.HttpParams().set('subIds', subscrptionId);
        return this.post(this.bbdeviceUpgradeUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getTradeInCredit(subscriptionId) {
        return this.get(this.tradeInCreditUrl + subscriptionId).pipe(operators_1.map((data) => data));
    }
    getEUPTradeInEligibility(subscriptionId) {
        return this.get(this.isEarlyUpgradeEligibleUrl + subscriptionId).pipe(operators_1.map((data) => data));
    }
}
exports.UpgradeService = UpgradeService;
//# sourceMappingURL=upgrade.service.js.map